export enum System {
  ALL = 'modules.data-management.filter.br-placeholder',
  XENTRY = 'modules.expert-tool.log-history.filter.system-xentry',
  EXPERT_TOOL = 'modules.expert-tool.log-history.filter.system-expert',
}
